import {FAKE_HTML_ATTR_AUTOCOMPLETE_VALUE} from 'common/types';
import * as R from 'ramda';
import React, {FunctionComponent} from 'react';
import MaskedInput, {MaskedInputProps} from 'react-text-mask';

export interface MaskedTextInputProps extends MaskedInputProps {
  inputRef: (ref: HTMLInputElement | null) => void;
}

export const UKRAINE_COUNTRY_CODE = '380';
export const createFullPhoneNumber = function(localPhone: string) {
  return `${UKRAINE_COUNTRY_CODE}${localPhone}`;
};

export const getLocalPhoneNumber = (fullPhoneNumber: string) => {
  const result=
  fullPhoneNumber && fullPhoneNumber.startsWith(UKRAINE_COUNTRY_CODE)
    ? fullPhoneNumber.slice(3)
    : fullPhoneNumber;
  return result;
}
export const parseMaskedPhoneNumber = (phone: string) =>
  phone.replace(/[-\s]/g, '');

export const normalizePhoneNumber = R.compose(
  createFullPhoneNumber,
  parseMaskedPhoneNumber
);

const MaskedPhoneInput: FunctionComponent<MaskedTextInputProps> = ({
  inputRef,
  ...rest
}: MaskedTextInputProps) => (
  <MaskedInput
    {...rest}
    ref={(ref: any) => {
      inputRef(ref ? ref.inputElement : null);
    }}
    pipe={(conformedValue: string) => {
      if(conformedValue.startsWith('0')) {
        return conformedValue.slice(1);
      }
      return getLocalPhoneNumber(conformedValue);
    }}
    mask={(value: string) => {
     if(value.startsWith('0')) {
       return [
         /0/,
         /\d/,
         /\d/,
         ' ',
         /\d/,
         /\d/,
         /\d/,
         '-',
         /\d/,
         /\d/,
         '-',
         /\d/,
         /\d/,
       ]
     } else
       if(value.startsWith(UKRAINE_COUNTRY_CODE)) {
       return [
         /3/,
         /8/,
         /0/,
         /\d/,
         /\d/,
         ' ',
         /\d/,
         /\d/,
         /\d/,
         '-',
         /\d/,
         /\d/,
         '-',
         /\d/,
         /\d/,
       ]
     }
     return [
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
      ]
    }}
    placeholderChar={'\u2000'}
    guide={false}
    type="tel"
    autoComplete={FAKE_HTML_ATTR_AUTOCOMPLETE_VALUE}
  />
);

export default MaskedPhoneInput;
